import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { RelationshipCompanyRouteGuard } from '@/components/layouts/RecordRouteGuard/RelationshipCompanyRouteGuard';
import RelationshipCompanyViewWrapper from '@/components/views/RelationshipCompanyView/RelationshipCompanyViewWrapper';
import { useFeatureFlagContext } from '@/context/featureFlagContext';
import { paths } from '@/app/paths';


const ViewRelationshipCompanyPage = () => {
	const { relationshipCompanyId } = useParams();
	const { getFeatureFlags, isLoading: isFeatureFlagsLoading } = useFeatureFlagContext();
	const isRelationshipContactsEnabled = Boolean(getFeatureFlags('relationshipContacts')?.active);

	if (isFeatureFlagsLoading) {
		return (
			<Box pt={1} display='flex' justifyContent='center'>
				<CircularProgress />
			</Box>
		);
	}

	if (!isRelationshipContactsEnabled) {
		return <Navigate to={`${paths.relationships}?tab=contacts`} replace />;
	}

	// Keyed so switching companies (e.g. via global search) remounts the view instead of showing the old company's data.
	return (
		<RelationshipCompanyRouteGuard>
			<Box pb={3}>
				<RelationshipCompanyViewWrapper key={relationshipCompanyId} />
			</Box>
		</RelationshipCompanyRouteGuard>
	);
};

export default ViewRelationshipCompanyPage;
